import React, { useState } from 'react';
import { Event } from '../lib/supabase';
import './EventForm.css';

interface EventFormProps {
  onSubmit: (event: Omit<Event, 'id' | 'created_at' | 'updated_at'>) => void;
  onCancel: () => void;
}

const EventForm: React.FC<EventFormProps> = ({ onSubmit, onCancel }) => {
  const [formData, setFormData] = useState({
    title: '',
    start_date: '',
    end_date: '',
    location: '',
    priority: '' as 'High' | 'Medium' | 'Low' | '',
    partnership_angle: '',
    description: '',
    notes: '',
    owner: '',
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!formData.title.trim() || !formData.start_date) {
      alert('Please fill in at least the title and start date.');
      return;
    }

    onSubmit({
      title: formData.title.trim(),
      start_date: formData.start_date,
      end_date: formData.end_date || undefined,
      location: formData.location.trim() || undefined,
      priority: formData.priority || undefined,
      partnership_angle: formData.partnership_angle.trim() || undefined,
      description: formData.description.trim() || undefined,
      notes: formData.notes.trim() || undefined,
      owner: formData.owner.trim() || undefined,
    });
  };

  return (
    <div className="event-form">
      <div className="card">
        <h3>Add New Event</h3>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Event Title *</label>
            <input
              type="text"
              name="title"
              value={formData.title}
              onChange={handleChange}
              placeholder="e.g., CES 2026 (Sports Tech)"
              required
              autoFocus
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Start Date *</label>
              <input
                type="date"
                name="start_date"
                value={formData.start_date}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label>End Date</label>
              <input
                type="date"
                name="end_date"
                value={formData.end_date}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Location</label>
              <input
                type="text"
                name="location"
                value={formData.location}
                onChange={handleChange}
                placeholder="e.g., Las Vegas"
              />
            </div>
            <div className="form-group">
              <label>Priority</label>
              <select
                name="priority"
                value={formData.priority}
                onChange={handleChange}
              >
                <option value="">Select priority</option>
                <option value="High">High</option>
                <option value="Medium">Medium</option>
                <option value="Low">Low</option>
              </select>
            </div>
          </div>

          <div className="form-group">
            <label>Owner</label>
            <input
              type="text"
              name="owner"
              value={formData.owner}
              onChange={handleChange}
              placeholder="e.g., John Doe"
            />
          </div>

          <div className="form-group">
            <label>Partnership Angle</label>
            <input
              type="text"
              name="partnership_angle"
              value={formData.partnership_angle}
              onChange={handleChange}
              placeholder="e.g., Tech convergence, adjacent partners"
            />
          </div>

          <div className="form-group">
            <label>Description</label>
            <textarea
              name="description"
              value={formData.description}
              onChange={handleChange}
              placeholder="Brief description of the event..."
              rows={4}
            />
          </div>

          <div className="form-group">
            <label>Notes</label>
            <textarea
              name="notes"
              value={formData.notes}
              onChange={handleChange}
              placeholder="Additional notes or details..."
              rows={3}
            />
          </div>

          <div className="form-actions">
            <button type="button" className="btn btn-secondary" onClick={onCancel}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary">
              Add Event
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EventForm;

